module.exports = __webpack_public_path__ + "img/score.ef7551a0.png";